module.exports = __webpack_public_path__ + "static/media/bonus_50000.8740be22.png";